<template>
    <div>
        <div class="row flex-column flex-lg-row justify-content-between mb-4">
            <div class="col-auto">
                <div class="intro">
                    <h1>Totaal export</h1>
                    <p>Genereer maandelijkse rapporten van al je Rockstars</p>
                    <table>
                        <tr />
                    </table>
                </div>
            </div>
            <div class="col col-lg-12">
                <div class="row align-items-end">
                    <div class="col-10">
                        <button
                            class="btn btn-secondary no-arrow w-100"
                            @click="handleOverviewGeneration"
                        >
                            Genereer overzicht
                        </button>
                    </div>
                    <div class="col-14">
                        <div class="row">
                            <div class="col-14">
                                <select v-model="selectedMonth">
                                    <option
                                        v-for="month in availableMonths"
                                        :key="month.value"
                                        :value="month.value"
                                    >
                                        {{ month.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-10">
                                <select v-model="selectedYear">
                                    <option
                                        v-for="year in availableYears"
                                        :key="year"
                                        :value="year"
                                    >
                                        {{ year }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <button
                            class="btn btn-secondary no-arrow w-100"
                            @click="handleReportGeneration"
                        >
                            Genereer rapport
                            {{ formatMonth(selectedMonth, selectedYear) }}
                            {{ selectedYear }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            :class="{
                'rock-monthly-export': true,
                'mb-4': true,
                'rock-monthly-export-loading': loading
            }"
        >
            <template v-if="!loading">
                <table v-if="reports.length > 0" class="table mb-0">
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Vervalt op:</th>
                            <th />
                        </tr>
                    </thead>
                    <tr v-for="report in reports" :key="report.id">
                        <td>{{ report.name || report.fileName }}</td>
                        <td>{{ formatDate(report.expires) }}</td>
                        <td class="text-right">
                            <button
                                v-if="report.finished"
                                class="btn btn-secondary btn-small no-arrow"
                                :disabled="downloading"
                                @click="handleReportDownload(report)"
                            >
                                Download
                            </button>
                            <div v-else class="d-flex justify-content-end">
                                <small class>
                                    <span class="text-nowrap"
                                        >Rapport wordt</span
                                    >
                                    gegenereerd</small
                                >
                                <span
                                    class="icon-info rock-monthly-export-icon-info"
                                    @click="handleShowPopover(report.id)"
                                    @mouseenter="handleShowPopover(report.id)"
                                />
                                <div class="position-relative">
                                    <RockPopover
                                        v-if="
                                            visiblePopoverReportId === report.id
                                        "
                                        title="Rapport wordt gegenereerd"
                                        class="popover-report-generation text-left"
                                        @close="handleClosePopover"
                                    >
                                        <p>
                                            Dit rapport wordt op de achtergrond
                                            nog gegenereerd. Ververs de pagina
                                            binnen enkele ogenblikken.
                                        </p>
                                    </RockPopover>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
                <div v-else class="p-5">
                    <h2>Geen gegenereerde rapporten beschikbaar.</h2>
                    Kies rechtsbovenaan van welke maand in welk jaar je een
                    rapport wilt genereren.
                </div>
            </template>
            <RockSpinner v-else />
        </div>
    </div>
</template>

<script>
import RockSpinner from '@/components/RockSpinner';
import RockPopover from '@/components/RockPopover';
import RockDownload from '@/mixins/RockDownload';
import RockDates from '@/mixins/RockDates';

const startDate = new Date(2017, 0, 1);
const startYear = startDate.getFullYear();
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth();

export default {
    components: {
        RockSpinner,
        RockPopover
    },

    mixins: [RockDownload, RockDates],

    data: () => ({
        loading: true,
        selectedYear: currentYear,
        selectedMonth: currentMonth,
        reports: [],
        visiblePopoverReportId: null
    }),

    computed: {
        availableYears() {
            return [...new Array(currentYear - startYear + 1)].map(
                (unit, index) => startYear + index
            );
        },

        availableMonths() {
            const selectedYear = this.selectedYear;
            return [...new Array(12)]
                .map((unit, index) => new Date(selectedYear, index))
                .filter((monthDate) => monthDate <= currentDate)
                .map((monthDate) => ({
                    value: monthDate.getMonth(),
                    text: this.formatMonth(monthDate.getMonth())
                }));
        }
    },

    created() {
        this.getReports();
    },

    methods: {
        handleReportGeneration() {
            this.$http
                .post('/reports/detailed', {
                    year: this.selectedYear,
                    month: this.selectedMonth
                })
                .then(() => {
                    this.generatingModalVisible = true;
                    this.loading = true;
                    setTimeout(() => {
                        this.getReports();
                    }, 2000);
                })
                .catch((error) => {
                    if (error.message !== 'ABORTED') console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleReportDownload(report) {
            const url = `reports/${report.id}`;
            const fallbackFilename = report.name || report.fileName;
            this.downloadFile({ url, fallbackFilename });
        },
        handleOverviewGeneration() {
            this.$http
                .post('reports/overview', {
                    year: this.selectedYear,
                    month: this.selectedMonth
                })
                .then(() => {
                    this.generatingModalVisible = true;
                    this.loading = true;
                    setTimeout(() => {
                        this.getReports();
                    }, 2000);
                })
                .catch((error) => {
                    if (error.message !== 'ABORTED') console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleShowPopover(reportId) {
            this.visiblePopoverReportId = reportId;
        },
        handleClosePopover() {
            this.visiblePopoverReportId = null;
        },
        getReports() {
            this.$http
                .get('reports')
                .then(({ data }) => {
                    this.reports = data.sort((a, b) =>
                        new Date(a.generated) > new Date(b.generated) ? -1 : 1
                    );
                })
                .catch((error) => console.error(error))
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style lang="scss">
.rock-monthly-export {
    position: relative;
    background: rgba(#232323, 0.9);

    &.rock-monthly-export-loading {
        height: 15rem;

        .backdrop {
            background-color: transparent;
        }
    }
}

.rock-monthly-export-icon-info {
    padding-left: 20px;
}
</style>
